<template>
  <!-- <v-container>
    <v-subheader class="pl-0">Income Chart Breakdown:</v-subheader>
  </v-container>-->
  <v-card class="mx-auto text-center mt-2 mb-2" color="white" flat>
    <!-- <v-card-text>
      <h2>tax distribution</h2>
    </v-card-text>-->

    <v-card-text>
      <canvas ref="myChart" width="100" height="40"></canvas>
    </v-card-text>
    <!-- 
    <v-divider></v-divider>

    <v-card-actions class="justify-center">
      <v-btn block text>Go to Report</v-btn>
    </v-card-actions>-->
  </v-card>
</template>

<script>
import Chart from "chart.js";
//import moment from "moment";

export default {
  data() {
    return {
      slider: 45
    };
  },

  watch: {
    "$store.state.selectedRange": function() {
      this.createChart();
    }
  },

  methods: {
    createChart() {
      // freeze the current gross value
      this.$store.dispatch("freezeGrossincome");

      // recreate the chart
      let el = this.$refs.myChart;
      doCreateChart(el, this.getValues);

      // unfreeze the current gross value
      this.$store.dispatch("unfreezeGrossincome");
    },
    getValues(mode) {
      //return [];
      let min = this.$store.getters.getRangeMin * 1000;
      let max = this.$store.getters.getRangeMax * 1000;
      let keyGrossValues = [9500, 12500, 50000, 100000, 125000, 150000];
      let arrResults = [];

      let calcIndValue = myGross => {
        this.$store.dispatch("setGrossIncome", myGross);
        arrResults.push({
          gross: myGross,
          data: this.$store.getters.getChartData
        });
      };

      // always insert the min calc values first
      calcIndValue(min);

      // insert other key points between min and max
      keyGrossValues.forEach(v => {
        if (v > min && v < max) calcIndValue(v);
      });

      // always insert the max calc values at the end
      calcIndValue(max);

      // I need to return [{ x: 0, y: 0; }, { x: 9500, y: 9500; }, { x: 12500, y: 10300; }]
      let arr = [];

      let fillArray = i => {
        arrResults.forEach(obj => {
          let results = obj.data;
          arr.push({ x: obj.gross, y: results[i] });
        });
      };

      if (mode == "GrossInc") fillArray(0);
      if (mode == "TabableInc") fillArray(1);
      if (mode == "TotalTax") fillArray(2);
      if (mode == "TotalIncomeTax") fillArray(3);
      if (mode == "TotalNI") fillArray(4);
      if (mode == "TakeHome") fillArray(5);

      return arr;
    }
  },
  mounted() {
    this.createChart();
  }
};

let _currChart = null;

const doCreateChart = (el, getValues) => {
  // if there is a current chart then destroy it first
  if (_currChart != null) _currChart.destroy();

  _currChart = new Chart(el, {
    type: "scatter",
    options: {
      scales: {
        xAxes: [
          {
            ticks: {
              callback: function(value, index, values) {
                return "£" + value / 1000 + "k";
              }
            }
          }
        ],
        yAxes: [
          {
            ticks: {
              callback: function(value, index, values) {
                return "£" + value / 1000 + "k";
              }
            }
          }
        ]
      }
    },
    data: {
      datasets: [
        {
          label: "Gross Income",
          data: getValues("GrossInc"),
          tension: 0,
          showLine: true,
          fill: false,
          borderColor: getLineColour("GrossInc"),
          borderWidth: 3
        },
        {
          label: "Taxable Income",
          data: getValues("TabableInc"),
          tension: 0,
          showLine: true,
          fill: false,
          borderColor: getLineColour("TabableInc"),
          borderWidth: 2
        },
        {
          label: "Take Home",
          data: getValues("TakeHome"),
          tension: 0,
          showLine: true,
          fill: false,
          borderColor: getLineColour("TakeHome"),
          borderWidth: 3
        },
        {
          label: "Total Tax",
          data: getValues("TotalTax"),
          tension: 0,
          showLine: true,
          fill: false,
          borderColor: getLineColour("TotalTax"),
          borderWidth: 3
        },
        {
          label: "Total Income Tax",
          data: getValues("TotalIncomeTax"),
          tension: 0,
          showLine: true,
          fill: false,
          borderColor: getLineColour("TotalIncomeTax"),
          borderWidth: 2
        },
        {
          label: "Total NI",
          data: getValues("TotalNI"),
          tension: 0,
          showLine: true,
          fill: false,
          borderColor: getLineColour("TotalNI"),
          borderWidth: 2
        }
      ]
    }
  });
};

const getLineColour = mode => {
  if (mode == "GrossInc") return "#B481D4";
  else if (mode == "TabableInc") return "#A2BBDE";
  else if (mode == "TotalTax") return "#231F7A";
  else if (mode == "TotalIncomeTax") return "#6EC79E";
  else if (mode == "TotalNI") return "#BBDE6F";
  else if (mode == "TakeHome") return "#D4B46A";
};
</script>

<style>
</style>